// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"c467bab07fa7efc6","5285":"dacfd3755ab2b1da"}[chunkId] + ".css";
};